import { HasAppModalRedirect } from '@models/dashboard.model'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface ProfileValue {
	id: string
	name?: string
	email?: string
	is_paid: boolean
	hasResearchOrigin: boolean
	showProfileConfigModal: boolean
	hasAppModalRedirect?: HasAppModalRedirect
	showRaioXModal?: boolean
}

const initialState: ProfileValue = {
	id: '',
	name: undefined,
	email: undefined,
	is_paid: false,
	hasResearchOrigin: true,
	showProfileConfigModal: false,
	hasAppModalRedirect: undefined,
	showRaioXModal: undefined,
}

export const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		setIsProfile: (
			state,
			{
				payload: {
					id,
					name,
					email,
					is_paid,
					hasResearchOrigin,
					showProfileConfigModal,
					hasAppModalRedirect,
					showRaioXModal,
				},
			}: PayloadAction<ProfileValue>
		) => {
			return {
				...state,
				id,
				name,
				email,
				is_paid,
				hasResearchOrigin,
				showProfileConfigModal,
				hasAppModalRedirect:
					state.hasAppModalRedirect === 'hide' ? 'hide' : hasAppModalRedirect,
				showRaioXModal: state.showRaioXModal === false ? false : showRaioXModal,
			}
		},
		setHasAppModalRedirect: (
			state,
			{ payload }: PayloadAction<HasAppModalRedirect>
		) => {
			state.hasAppModalRedirect = payload
		},
		setShowRaioXModal: (state, { payload }: PayloadAction<boolean>) => {
			state.showRaioXModal = payload
		},
	},
})

export const profileCreators = profileSlice.actions

export const profileReducer = profileSlice.reducer
